import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
var ɵ0 = function (state) { return state.course.courses; }, ɵ1 = function (courses) {
    return courses.map(function (c) {
        var newCrs = tslib_1.__assign({}, c);
        return newCrs;
    })
        .sort(function (a, b) { return new Date(b.publication_date).getTime() - new Date(a.publication_date).getTime(); });
};
// import {pipe} from 'rxjs';
// import {map} from 'rxjs/operators';
export var selectAllArticles = createSelector(ɵ0, ɵ1);
var preferredOrder = ['politics', 'history', 'literature', 'philosophy___religion', 'economics'];
var ɵ2 = function (state) { return state.course.courses; }, ɵ3 = function (courses) {
    return courses.map(function (c) {
        var newCrs = tslib_1.__assign({}, c);
        return newCrs;
    })
        //Always sort courses by publish date (desc)
        .sort(function (a, b) { return new Date(b.publication_date).getTime() - new Date(a.publication_date).getTime(); });
};
export var selectAllCourses = createSelector(ɵ2, ɵ3);
var ɵ4 = function (state) { return state.course.courses; }, ɵ5 = function (courses) {
    return courses.map(function (c) {
        var newCrs = {
            title: c.title,
            url_slug: c.url_slug,
            publication_date: c.publication_date
        };
        return newCrs;
    })
        .sort(function (a, b) { return new Date(a.publication_date).getTime() - new Date(b.publication_date).getTime(); });
};
export var selectAllCoursesForNav = createSelector(ɵ4, ɵ5);
export function getCurrentCourse(courseState) {
    return courseState.courseDetails[courseState.currentCourse] || courseState.courses.find(function (c) { return c.url_slug === courseState.currentCourse; });
}
export function getCurrentLesson(coursesState) {
    var course = getCurrentCourse(coursesState);
    return course && course.lectures.find(function (c) { return c.url_slug === coursesState.currentLesson; });
}
export function getCurrentCourseContentByCourse(course, coursesState) {
    return course && coursesState.currentContentItem && course.lectures
        .filter(function (c) { return c; })
        .find(function (c) { return c.system_id === coursesState.currentContentItem.system_id; });
}
export function getCurrentCourseContent(coursesState) {
    var course = getCurrentCourse(coursesState);
    return getCurrentCourseContentByCourse(course, coursesState);
}
var ɵ6 = function (state) { return state.course; }, ɵ7 = function (state) {
    return getCurrentCourse(state);
};
export var selectCurrentCourse = createSelector(ɵ6, ɵ7);
var ɵ8 = function (state) { return state.course; }, ɵ9 = function (state) {
    return getCurrentLesson(state);
};
export var selectCurrentLesson = createSelector(ɵ8, ɵ9);
var ɵ10 = function (state) { return state.course; }, ɵ11 = function (course) { return course.courses.map(function (c) { return ({ slug: c.url_slug, codename: c.system_codename }); }); };
export var selectCourseSlugsToCodeName = createSelector(ɵ10, ɵ11);
var ɵ12 = function (state) { return state.course; }, ɵ13 = function (state) { return state.currentLesson; };
export var selectCurrentLessonId = createSelector(ɵ12, ɵ13);
var ɵ14 = function (state) { return state.course; }, ɵ15 = function (state) { return ({
    courseId: (getCurrentCourse(state) || { system_id: null }).system_id,
    lessonId: (getCurrentLesson(state) || { system_id: null }).system_id,
    contentId: (getCurrentCourseContent(state) || { system_id: null }).system_id
}); };
export var selectCurrentStateSystemIds = createSelector(ɵ14, ɵ15);
var ɵ16 = function (state) { return state.course; }, ɵ17 = function (state) {
    var crs = getCurrentCourse(state);
    return (crs && crs.donation_url) || 'https://secured.hillsdale.edu/hillsdale/support-hillsdale-college?utm_campaign=online_symposium&sc=MK420UN2';
};
export var selectCurrentDonationURL = createSelector(ɵ16, ɵ17);
export var getVideoLoc = function () {
    return createSelector(function (state, props) { return state.course.videoProgress[props.videoId]; }, function (progress, props) { return progress; });
};
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17 };
